export enum InlineEditorTriggerActionType {
  StartedEditingRow = "startedEdit",
  StoppedEditingRow = "stoppedEdit",
  DeleteRow = 'delete',
  SaveRow = 'editComplete',
  AddItemAsNewRow = 'addRow',
  RenewRow = 'renew',
}
